import { useMemo } from "react";
import type { OmnisPrompt } from "./types";
import { useCustomPromptsQuery } from "./useCustomPromptsQuery";

export const useCustomPrompts = () => {
  const { data } = useCustomPromptsQuery();

  const omnisIQPrompts = useMemo(() => {
    if (!data) return EMPTY_PROMPTS;

    const { originals: omnisPrompts, overrides: overridedPrompts } = data.OmnisIQ.prompts;

    for (const overridePrompt of overridedPrompts) {
      const omnisPromptToOverride = omnisPrompts.find((val) => val.id == overridePrompt.overrideId);

      if (!omnisPromptToOverride) continue;

      omnisPromptToOverride.originalBody = omnisPromptToOverride.prompt_body;

      if (overridePrompt.prompt) omnisPromptToOverride.prompt_body = overridePrompt.prompt;

      omnisPromptToOverride.idOfOverride = overridePrompt.id;
      omnisPromptToOverride.favorite = overridePrompt.favorite;
    }

    return omnisPrompts.sort((a, b) => a.order - b.order);
  }, [data]);

  return {
    omnisIQPrompts,
    omnisFavorites: data?.OmnisIQ.favorites ?? EMPTY_FAVORITES,
    userPrompts: data?.userPrompts.prompts ?? {},
    userFavorites: data?.userPrompts.favorites ?? EMPTY_FAVORITES,
  };
};

const EMPTY_PROMPTS: OmnisPrompt[] = [];
const EMPTY_FAVORITES: string[] = [];
